import * as React from 'react';

import { VerifiedSkills_CareerBand as CareerBand } from '__generated__/graphql-types';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

type Props = {
  careerBand?: CareerBand | null;
};

const SkillPathwayCareerBandKeyDetailsItem = ({ careerBand }: Props) => {
  const earlyCareerTitle = _t('Early professional');
  const earlyCareerSubtitle = _t('Build foundational knowledge to start contributing right away');
  const skilledProfessionalTitle = _t('Professional');
  const skilledProfessionalSubtitle = _t('Advance your skills to deliver results independently');

  switch (careerBand) {
    case CareerBand.EarlyCareerProfessional:
      return <KeyInformationDetailsItem title={earlyCareerTitle} subtitle={earlyCareerSubtitle} />;
    default:
      return <KeyInformationDetailsItem title={skilledProfessionalTitle} subtitle={skilledProfessionalSubtitle} />;
  }
};

export default SkillPathwayCareerBandKeyDetailsItem;
